import { useQuery } from 'react-query';
import getOrder from 'data/requests/getOrder';
import { Order } from 'model/order';

const useOrder = (id: string) => {
  const { data, isLoading } = useQuery<Order>(['order', id], () =>
    getOrder(id),
  );

  return { order: data, isLoading };
};

export default useOrder;
